import { callInternal } from './internal.js';

export async function submitFeedback(content: string): Promise<{ ok: boolean; msg?: string }> {
	try {
		const res = await callInternal({
			short_name: 'base',
			action: '/other/add_feedback',
			method: 'POST',
			body: {
				content,
				source: 'web',
			},
			av: '1',
		});
		return { ok: Number(res.code) === 0, msg: res.msg || `code=${res.code}` };
	} catch (e) {
		return { ok: false, msg: e instanceof Error ? e.message : String(e) };
	}
}
